export const functionalityOption = [
  { label: "Login", slug: "login", id: 1 },
  { label: "OTP", slug: "otp", id: 2 },
  { label: "Request Access", slug: "request_access", id: 3 },
  { label: "Send Reset Mail", slug: "send_reset_mail", id: 4 },
  { label: "Create New Password", slug: "create_new_password", id: 5 },
  { label: "Dashboard / Menu", slug: "dashboard_menu", id: 6 },
  { label: "Withdraw Naira", slug: "withdraw_naira", id: 7 },
  { label: "Invite User", slug: "invite_user", id: 8 },
  { label: "View Activity Table", slug: "view_activity_table", id: 9 },
  {
    label: "Update Account / Profile Info",
    slug: "update_account_profile_info",
    id: 10,
  },
  {
    label: "View Fiat / Stablecoins Wallet",
    slug: "view_fiat_stablecoins_wallet",
    id: 11,
  },
  { label: "Buy FCY", slug: "buy_fcy", id: 12 },
  { label: "Sell FCY", slug: "sell_fcy", id: 13 },
  { label: "Buy USDT", slug: "buy_usdt", id: 14 },
  { label: "Sell USDT", slug: "sell_usdt", id: 15 },
  { label: "Buy USDC", slug: "buy_usdc", id: 16 },
  { label: "Sell USDC", slug: "sell_usdc", id: 17 },
  { label: "Receive USDC", slug: "receive_usdc", id: 18 },
  { label: "Receive USDT", slug: "receive_usdt", id: 19 },
  { label: "Convert USDC", slug: "convert_usdc", id: 20 },
  { label: "Convert USDT", slug: "convert_usdt", id: 21 },
  { label: "Swap FCY", slug: "swap_fcy", id: 22 },
  { label: "Transfer FCY", slug: "transfer_fcy", id: 23 },
  { label: "Transfer LCY", slug: "transfer_lcy", id: 24 },
  { label: "Transfer USDC", slug: "transfer_usdc", id: 25 },
  { label: "Transfer USDT", slug: "transfer_usdt", id: 26 },
  { label: "View Card Details", slug: "view_card_details", id: 27 },
  { label: "Debit Card", slug: "debit_card", id: 28 },
  { label: "Deposit into Card", slug: "deposit_into_card", id: 29 },
  { label: "Save Beneficiary - Fiat", slug: "save_beneficiary_fiat", id: 30 },
  {
    label: "Save Beneficiary - Stablecoins",
    slug: "save_beneficiary_stablecoins",
    id: 31,
  },
  { label: "Delete Beneficiary", slug: "delete_beneficiary", id: 32 },
  {
    label: "Transfer to Beneficiary",
    slug: "transfer_to_beneficiary",
    id: 33,
  },
  { label: "Withdraw LCY", slug: "withdraw_lcy", id: 34 },
  { label: "Withdraw Commissions", slug: "withdraw_commissions", id: 35 },
  { label: "Profile Settings", slug: "profile_settings", id: 36 },
  { label: "Bank Settings", slug: "bank_settings", id: 37 },
  { label: "Security Settings", slug: "security_settings", id: 38 },
  { label: "View Referrals", slug: "view_referrals", id: 39 },
  { label: "View Rates - Fiat", slug: "view_rates_fiat", id: 40 },
  {
    label: "View Rates - Stablecoins",
    slug: "view_rates_stablecoins",
    id: 41,
  },
  { label: "View Rates - Whatsapp", slug: "view_rates_whatsapp", id: 42 },
  { label: "Show LCY Account", slug: "show_lcy_account", id: 43 },
  { label: "Show USDC Wallet", slug: "show_usdc_wallet", id: 44 },
  { label: "Show USDT Wallet", slug: "show_usdt_wallet", id: 45 },
  { label: "Show FCY Account", slug: "show_fcy_account", id: 46 },
];
